import type { OrganizationRiskSetting, SustainabilityArea } from '@app/src/types/resourceExplorer'
import type { TopicCard } from './Cards/riskIndexCards'

export type AreaFilter = SustainabilityArea | 'all'
export type TopicFilter = number | 'all'
export type StatusFilter = 'all' | 'active' | 'inactive'

export interface RiskIndexFilterState {
  area: AreaFilter
  topic: TopicFilter
  status: StatusFilter
}

export const NO_RISK_INDEX_FILTERS: RiskIndexFilterState = { area: 'all', topic: 'all', status: 'all' }

export const hasRiskIndexFilters = (filters: RiskIndexFilterState): boolean =>
  filters.area !== 'all' || filters.topic !== 'all' || filters.status !== 'all'

const matchesStatus = (isActive: boolean, status: StatusFilter) =>
  status === 'all' || (status === 'active' ? isActive : !isActive)

export const filterTopicCards = (cards: TopicCard[], filters: RiskIndexFilterState): TopicCard[] =>
  cards.filter(
    card =>
      (filters.area === 'all' || card.area === filters.area) &&
      (filters.topic === 'all' || card.topicId === filters.topic) &&
      matchesStatus(card.isActive, filters.status),
  )

/** Standalone indices belong to no topic, so the topic filter has nothing to match on here. */
export const filterRiskSettings = (
  settings: OrganizationRiskSetting[],
  filters: RiskIndexFilterState,
): OrganizationRiskSetting[] =>
  settings.filter(
    setting =>
      (filters.area === 'all' || setting.riskType.sustainabilityArea === filters.area) &&
      matchesStatus(setting.isActivated, filters.status),
  )
